import {SET_FORM_DATA} from "../phonebookReducer";

const initialState = {
    'school': "0",
    'idOrg': "0"
};

export const phonebookFormReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FORM_DATA:
            return action.payload;
        default:
            return state;
    }
};
